//* a claim address is what the customer actually inputs on the crew-ui during claim creation
import { z } from 'zod';
import { helperSchema, nullifyString } from '../../zodExtensions.js';
// todo: make this 2 or 3
// no min length: countries without a state/province subdivision legitimately have none
const stateOrProvinceCode = z.string().nullish(); // two letter state code // field in Address is expected to be of format ISO 3166
// * order address
export const orderAddress = z.object({
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    line1: z.string().optional(),
    line2: z.string().optional(),
    city: z.string().optional(),
    countryCode: z
        .string()
        .length(2, { message: 'Country code should a be two letters' })
        .optional(), // two letter country code ISO 3166
    // ? renamed from provinceCode
    stateOrProvinceCode: z.string().optional(),
    // ? renamed from zip
    postalCode: z.string().optional(),
    phone: z.string().optional(),
});
//* may be different from the original order address // especially if the customer has moved since the order was placed
export const claimAddress = orderAddress.required().extend({
    line2: nullifyString(z.string()).optional(),
    phone: nullifyString(z.string()).optional(),
    stateOrProvinceCode,
    // countries with no postal system legitimately have none; the crew UI requires it for US only
    postalCode: nullifyString(z.string()).optional(),
    id: z.number().optional(),
});
export const claimAddressCreate = claimAddress.omit({ id: true });
export const locationAddress = claimAddress
    .omit({
    firstName: true,
    lastName: true,
})
    .merge(z.object({ name: helperSchema.nonEmptyString }));
//* address verification
const addressFieldDiff = z.object({
    field: z.string(),
    original: z.string().nullish(),
    suggested: z.string().nullish(),
});
export const verifyAddressResponse = z.discriminatedUnion('ok', [
    z.object({ ok: z.literal(true) }),
    z.object({
        ok: z.literal(true),
        corrections: z.array(addressFieldDiff),
    }),
    z.object({
        ok: z.literal(false),
        errors: z.array(z.string()),
    }),
]);
//# sourceMappingURL=address.js.map